import EsusView from 'components/esus/EsusView'

export default function FichaAtividadeColetivaView() {
  return <EsusView url='/pec/user/cds/atividadeColetiva' />
}
